/** Example contract used by the merkle update demo transaction. */
export const MERKLE_EXAMPLE_ADDRESS = 'EQD_5KMZVIqzYY91-t5CdRD_V71wRrVzxDXu9n2XEwz2wwdv';
